import React from "react";

export const SelectValue = ({ placeholder }) => {
  return <span className="text-gray-900 dark:text-gray-100">{placeholder}</span>;
};

export const Select = ({ label, value, onValueChange, children }) => {
  return (
    <div className="space-y-2">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </label>
      )}
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring focus:ring-blue-300 text-gray-900 dark:bg-gray-800 dark:text-gray-100"
        >
          {children}
        </select>
      </div>
    </div>
  );
};


export const SelectTrigger = ({ children, className = "" }) => {
  return <div className={`cursor-pointer ${className}`}>{children}</div>;
};


export const SelectContent = ({ children }) => {
  return <>{children}</>;
};

export const SelectItem = ({ value, children }) => {
  return <option value={value}>{children}</option>;
};